// useAppData.ts
import { AppDataContext } from "@/AppDataContext";
import { useContext } from "react";

export const useDataContext = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error("useAppData must be used inside <AppDataProvider/>");
  }
  return context;
};
